import { useQuery } from '@apollo/react-hooks'

import { IPaginationInput } from '../../types/common'
import { IGetCorporationTypesByAdminData } from '../../types/businesses'
import { GET_CORPORATION_TYPES_BY_ADMIN } from '../../queries/businesses'
import { useQueryParams } from '../../../utils'

export const CORPORATION_TYPES_ROWS_PER_PAGE = [15, 30, 40]

export const useCorporationTypes = () => {
  const [{ query }] = useQueryParams()
  const page = query.page ? parseInt(query.page) : 1
  const limit =
    query.limit && CORPORATION_TYPES_ROWS_PER_PAGE.includes(parseInt(query.limit))
      ? parseInt(query.limit)
      : CORPORATION_TYPES_ROWS_PER_PAGE[0]

  const { data, ...q } = useQuery<IGetCorporationTypesByAdminData, { pagination: IPaginationInput }>(
    GET_CORPORATION_TYPES_BY_ADMIN,
    {
      variables: {
        pagination: { offset: (page - 1) * limit, limit },
      },
      fetchPolicy: 'cache-first',
    }
  )

  const corporationTypes = data?.getCorporationTypesByAdmin.data ?? []
  const total = data?.getCorporationTypesByAdmin.total ?? 0

  return {
    corporationTypes,
    total,
    page,
    limit,
    ...q,
  }
}
